@if (form) {
<nz-input-group
  [nzAddOnBefore]="addOnBeforeTemplate"
  [nzStatus]="status"
  [formGroup]="form"
>
  <ng-template #addOnBeforeTemplate>
    <nz-select
      class="phone-select"
      nzShowSearch
      nzServerSearch
      i18n-placeholder
      placeholder="Call code"
      formControlName="prefix"
      (nzOnSearch)="search($event)"
      [nzLoading]="loading"
      role="presentation"
      autocomplete="off"
    >
      @for (o of options; track o) {
      <nz-option [nzLabel]="o.label" [nzValue]="o.value"></nz-option>
      }
    </nz-select>
  </ng-template>
  <input
    [nzStatus]="status"
    [placeholder]="placeholder"
    formControlName="phone"
    nz-input
  />
</nz-input-group>
}
